import _defineProperty from "/codebuild/output/src2317851137/src/gatsby-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../types.js').Handle} Handle
 */
import { association } from '../util/association.js';
import { containerPhrasing } from '../util/container-phrasing.js';
import { safe } from '../util/safe.js';
import { track } from '../util/track.js';
linkReference.peek = linkReferencePeek;
/**
 * @type {Handle}
 * @param {LinkReference} node
 */

export function linkReference(node, _, context, safeOptions) {
  var type = node.referenceType;
  var exit = context.enter('linkReference');
  var subexit = context.enter('label');
  var tracker = track(safeOptions);
  var value = tracker.move('[');
  var text = containerPhrasing(node, context, _objectSpread({
    before: value,
    after: ']'
  }, tracker.current()));
  value += tracker.move(text + '][');
  subexit(); // Hide the fact that we’re in phrasing, because escapes don’t work.

  var stack = context.stack;
  context.stack = [];
  subexit = context.enter('reference'); // Note: for proper tracking, we should reset the output positions when we end
  // up making a `shortcut` reference, because then there is no brace output.
  // Practically, in that case, there is no content, so it doesn’t matter that
  // we’ve tracked one too many characters.

  var reference = safe(context, association(node), _objectSpread({
    before: value,
    after: ']'
  }, tracker.current()));
  subexit();
  context.stack = stack;
  exit();

  if (type === 'full' || !text || text !== reference) {
    value += tracker.move(reference + ']');
  } else if (type === 'shortcut') {
    // Remove the unwanted `[`.
    value = value.slice(0, -1);
  } else {
    value += tracker.move(']');
  }

  return value;
}
/**
 * @type {Handle}
 */

function linkReferencePeek() {
  return '[';
}